import z from "zod";

import createSchemaUtils from "@core/helpers/createSchemaUtils";
import { QueryRequestOptionsSchema, SafeNameSchema } from "../common";
import { ODataQueryDatasourceSchema } from "./ODataDatasource";
import { RESTDatasourceSchema } from "./RESTDatasource";

export * from "./ODataDatasource";
export * from "./RESTDatasource";

//update CustomDatasource's exec field to mimic function exec(args:unknown, options:QueryRequestOptions):Promise<unknown>
export const CustomDatasourceSchema = z.object({
    exec: z.function({
        input: z.tuple([z.any(), QueryRequestOptionsSchema]),
    }).output(z.promise(z.any()))
})
export type CustomDatasource = z.infer<typeof CustomDatasourceSchema>;
export const CustomDatasource = createSchemaUtils(CustomDatasourceSchema);

const DatasourceCachingSchema = z.object({
    target: z.enum(["global", "user"]).default("global").optional(),
    duration: z.number().min(0).default(120).optional(), // in seconds
}).or(z.literal(true)).optional();

export const DatasourceRecordSchema = z.record(
    SafeNameSchema,
    z.union([
        z.object({
            type: z.literal("rest"),
            config: RESTDatasourceSchema,
            caching: DatasourceCachingSchema
        }),
        z.object({
            type: z.literal("odata"),
            config: ODataQueryDatasourceSchema,
            caching: DatasourceCachingSchema
        }),
        z.object({
            type: z.literal("custom"),
            config: CustomDatasourceSchema,
            caching: DatasourceCachingSchema
        }),
    ])
);
export type DatasourceRecord = z.infer<typeof DatasourceRecordSchema>;
export const DatasourceRecord = createSchemaUtils(DatasourceRecordSchema);
